import { transformVoiceMessageDtoToModel } from "../VoiceMessage/VoiceMessageModel";
import { VoiceConversationDto } from "./VoiceConversationDto";
import { VoiceConversationModel } from "./VoiceConversationModel";

export const transformVoiceConversationDtoToModel = (
  dto: VoiceConversationDto
): VoiceConversationModel => ({
  ...dto,
  ...transformVoiceMessageDtoToModel(dto),
});
